export const NATIVE_APP_UTM_PARAMS_KEY = "native_app_utm_params";
export const NATIVE_APP_GUEST_KEY = "auth_access_restricted_cta";

const saveNativeAppUtmParams = () => {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  if (params.get("utm_medium") === "app") {
    const appUtmData = {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_content: params.get("utm_content") || "",
      utm_term: params.get("utm_term") || "",
      purchase_source: params.get("purchase_source") || "",
    };
    sessionStorage.setItem(NATIVE_APP_UTM_PARAMS_KEY, JSON.stringify(appUtmData));
  }
};

const readUtmParams = () => {
  if (typeof window === "undefined") {
    return {
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      utm_content: "",
      utm_term: "",
      purchase_source: "",
    };
  }

  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_content: params.get("utm_content") || "",
    utm_term: params.get("utm_term") || "",
    purchase_source: params.get("purchase_source") || "",
  };
};

const isNativeAppUtmParams = (utmParams: { utm_source: string; utm_medium: string }) =>
  utmParams.utm_medium === "app" &&
  (utmParams.utm_source === "apple_ios" || utmParams.utm_source === "android_app");

const isGuestAppUser = (utmParams: { utm_campaign: string }) =>
  utmParams.utm_campaign === NATIVE_APP_GUEST_KEY;

const isComingFromNativeApp = (): {
  utmParams: { [key: string]: string | undefined | null };
  isComingFromApp: boolean;
  isGuestAppUser: boolean;
} => {
  if (typeof window === "undefined") {
    return {
      utmParams: {},
      isComingFromApp: false,
      isGuestAppUser: false,
    };
  }

  // First check sessionStorage for saved UTM params
  const savedParams = sessionStorage.getItem(NATIVE_APP_UTM_PARAMS_KEY);
  if (savedParams) {
    const utmParams = JSON.parse(savedParams);
    return {
      isComingFromApp: isNativeAppUtmParams(utmParams),
      utmParams,
      isGuestAppUser: isNativeAppUtmParams(utmParams) && isGuestAppUser(utmParams),
    };
  }

  // Fall back to checking URL params
  const utmParams = readUtmParams();
  return {
    isComingFromApp: isNativeAppUtmParams(utmParams),
    utmParams,
    isGuestAppUser: isNativeAppUtmParams(utmParams) && isGuestAppUser(utmParams),
  };
};

export { saveNativeAppUtmParams, readUtmParams, isComingFromNativeApp };
